import { useState } from "react";
import "./LmsOritent.css";

// Simple inline SVG icons (no external icon library needed)
const Icon = ({ path, size = 17, fill = "none", strokeWidth = 2, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {path}
  </svg>
);

const LayoutGrid = (props) => (
  <Icon
    {...props}
    path={
      <>
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </>
    }
  />
);

const BookOpen = (props) => (
  <Icon
    {...props}
    path={
      <>
        <path d="M2 4.5C2 4.5 5 3 8 3s6 1.5 6 1.5V19c0-.5-3-1.5-6-1.5S2 19 2 19V4.5Z" />
        <path d="M22 4.5C22 4.5 19 3 16 3s-6 1.5-6 1.5V19c0-.5 3-1.5 6-1.5s6 1.5 6 1.5V4.5Z" />
      </>
    }
  />
);

const ClipboardList = (props) => (
  <Icon
    {...props}
    path={
      <>
        <rect x="5" y="4" width="14" height="17" rx="2" />
        <rect x="9" y="2.5" width="6" height="3" rx="1" />
        <path d="M8.5 10.5h7M8.5 14h7M8.5 17.5h4" />
      </>
    }
  />
);

const Calendar = (props) => (
  <Icon
    {...props}
    path={
      <>
        <rect x="3.5" y="4.5" width="17" height="16" rx="2" />
        <path d="M3.5 9.5h17M8 3v3M16 3v3" />
      </>
    }
  />
);

const MessageSquare = (props) => (
  <Icon
    {...props}
    path={<path d="M4 4.5h16v12H8l-4 4v-4H4z" />}
  />
);

const LifeBuoy = (props) => (
  <Icon
    {...props}
    path={
      <>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="4" />
        <path d="M6.3 6.3l3.4 3.4M14.3 14.3l3.4 3.4M17.7 6.3l-3.4 3.4M9.7 14.3l-3.4 3.4" />
      </>
    }
  />
);

const Settings = (props) => (
  <Icon
    {...props}
    path={
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 13.5a1.7 1.7 0 0 0 .35 1.9l.05.05a2 2 0 1 1-2.9 2.9l-.05-.05a1.7 1.7 0 0 0-1.9-.35 1.7 1.7 0 0 0-1 1.55V19a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.55 1.7 1.7 0 0 0-1.9.35l-.05.05a2 2 0 1 1-2.9-2.9l.05-.05a1.7 1.7 0 0 0 .35-1.9 1.7 1.7 0 0 0-1.55-1H4a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.55-1 1.7 1.7 0 0 0-.35-1.9l-.05-.05a2 2 0 1 1 2.9-2.9l.05.05a1.7 1.7 0 0 0 1.9.35H10a1.7 1.7 0 0 0 1-1.55V4a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.55 1.7 1.7 0 0 0 1.9-.35l.05-.05a2 2 0 1 1 2.9 2.9l-.05.05a1.7 1.7 0 0 0-.35 1.9V10a1.7 1.7 0 0 0 1.55 1H20a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
      </>
    }
  />
);

const ChevronDown = (props) => (
  <Icon {...props} path={<path d="M6 9l6 6 6-6" />} />
);

const ChevronRight = (props) => (
  <Icon {...props} path={<path d="M9 18l6-6-6-6" />} />
);

const Search = (props) => (
  <Icon
    {...props}
    path={
      <>
        <circle cx="11" cy="11" r="7" />
        <path d="M21 21l-4.35-4.35" />
      </>
    }
  />
);

const Bell = (props) => (
  <Icon
    {...props}
    path={
      <>
        <path d="M6 8a6 6 0 1 1 12 0c0 4 1.5 5.5 1.5 5.5H4.5S6 12 6 8z" />
        <path d="M10 20a2 2 0 0 0 4 0" />
      </>
    }
  />
);

const Check = (props) => <Icon {...props} path={<path d="M20 6L9 17l-5-5" />} />;

const Circle = ({ fill = "currentColor", ...props }) => (
  <Icon {...props} fill={fill} path={<circle cx="12" cy="12" r="10" />} />
);

const navItems = [
  { key: "dashboard", label: "Dashboard", icon: LayoutGrid },
  { key: "courses", label: "My courses", icon: BookOpen },
  { key: "assignments", label: "Assignments", icon: ClipboardList },
  { key: "calendar", label: "Calendar", icon: Calendar },
  { key: "messages", label: "Messages", icon: MessageSquare },
  { key: "help", label: "Help centre", icon: LifeBuoy },
];

const pathSteps = [
  { title: "Find your courses", done: true },
  { title: "Read the syllabus", done: true },
  { title: "Submit a practice task", done: false },
  { title: "Message your instructor", done: false },
];

const faqs = [
  {
    q: "Where do I find my course materials?",
    a: "Open \u201cMy courses\u201d in the left sidebar, then choose a course to see its modules, readings, and recordings.",
  },
  {
    q: "How do I submit an assignment?",
    a: "Go to Assignments, pick the task, and use the upload area at the bottom of the page. You'll get a confirmation once it's received.",
  },
  {
    q: "What if I miss a deadline?",
    a: "Message your instructor as soon as you can from the Messages tab. Late policies vary by course and are listed on each syllabus.",
  },
  {
    q: "Who do I contact for technical issues?",
    a: "Use the Help centre tab to open a support ticket, or check the FAQ articles there first \u2014 most login and access issues are covered.",
  },
];

export default function LMSOrientation() {
  const [active, setActive] = useState("dashboard");
  const [openFaq, setOpenFaq] = useState(0);
  return (
    <div className="lms">
      {/* Main content */}
      <main className="lms-main">
        {/* Top bar */}
        <div className="lms-topbar">
          <div className="lms-search">
            <Search size={15} className="lms-search-icon" />
            <input
              placeholder="Search courses, people, help articles"
              className="lms-search-input"
            />
          </div>
          <div className="lms-topbar-right">
            <Bell size={18} className="lms-bell" />
            <div className="lms-avatar">MP</div>
          </div>
        </div>

        <div className="lms-content">
          {/* Welcome banner */}
          <div className="lms-welcome">
            <h1 className="lms-welcome-title">Welcome back, Maya</h1>
            <p className="lms-welcome-subtitle">
              Here's a quick orientation to help you find your way around before classes start.
            </p>
          </div>

          {/* Orientation path - signature element */}
          <div className="lms-card lms-path-card">
            <h2 className="lms-section-title">Your orientation path</h2>
            <div className="lms-path">
              {pathSteps.map((step, i) => (
                <div key={step.title} className="lms-path-step-wrap">
                  <div className="lms-path-step">
                    <div
                      className={`lms-path-dot${
                        step.done ? " lms-path-dot--done" : ""
                      }`}
                    >
                      {step.done ? <Check size={16} /> : <Circle size={8} fill="currentColor" />}
                    </div>
                    <span
                      className={`lms-path-label${
                        step.done ? "" : " lms-path-label--pending"
                      }`}
                    >
                      {step.title}
                    </span>
                  </div>
                  {i < pathSteps.length - 1 && (
                    <div
                      className={`lms-path-line${
                        pathSteps[i + 1].done || step.done ? " lms-path-line--done" : ""
                      }`}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Two column: courses + FAQ */}
          <div className="lms-columns">
            <div className="lms-courses-col">
              <h2 className="lms-section-title">Jump back in</h2>
              {[
                { name: "Intro to Data Science", meta: "3 new items" },
                { name: "Academic Writing 101", meta: "1 assignment due" },
                { name: "World History Survey", meta: "Up to date" },
              ].map((c) => (
                <div key={c.name} className="lms-course-card">
                  <div>
                    <p className="lms-course-name">{c.name}</p>
                    <p className="lms-course-meta">{c.meta}</p>
                  </div>
                  <ChevronRight size={16} className="lms-chevron" />
                </div>
              ))}
            </div>

            <div className="lms-faq-col">
              <h2 className="lms-section-title">Frequently asked questions</h2>
              <div className="lms-card lms-faq-card">
                {faqs.map((item, i) => {
                  const isOpen = openFaq === i;
                  return (
                    <div key={item.q} className="lms-faq-item">
                      <button
                        onClick={() => setOpenFaq(isOpen ? -1 : i)}
                        className="lms-faq-question"
                      >
                        <span className="lms-faq-question-text">{item.q}</span>
                        <ChevronDown
                          size={16}
                          className={`lms-faq-chevron${isOpen ? " lms-faq-chevron--open" : ""}`}
                        />
                      </button>
                      {isOpen && (
                        <p className="lms-faq-answer">
                          {item.a}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
